import { IndicatorType } from 'shared/types/transformation';
import { getReadableIndicatorType } from 'shared/utils/transformation';

// -- For use in filtering safelist terms
export const SELECT_TYPE_OPTIONS = Object.values(IndicatorType).map(type => ({
    name: type,
    label: getReadableIndicatorType(type),
}));

export const SEARCH_FILTER_KEY = 'entity';
export const TERM_TYPE_KEY = 'type';

// This is hardcoded temporarily. The component using this constant has only the type field to filter through at the moment, once an additional field is added to filter create a type for this FIXME
export const MULTI_OPTION_SELECT_FIELDS: ['type']  = [
  TERM_TYPE_KEY,
];
// --